import { useNavigate } from 'react-router-dom'
import { useCallback, useEffect, useState } from 'react'

import styles from './styles.module.scss'

import { useCurso } from '@/hooks/useCurso'
import { InstitutionRepository } from '@/pages/admin/repositories/institution.repository'
import { CursoRepository } from '@/pages/admin/repositories/curso.repository'

interface InstitutionCourse {
  id: number
  titulo: string
}

interface IProps {
  category: string
  setCategory: (category: string) => void
}

export const SearchCourse = ({ category, setCategory }: IProps) => {
  const [city, setCity] = useState('')
  const [cities, setCities] = useState<string[]>([])
  const [neighborhoods, setNeighborhoods] = useState<string[]>([])
  const [institutionsCourse, setInstitutionsCourses] = useState<any[]>([])
  const [institutions, setInstitutions] = useState<InstitutionCourse[]>([])
  const { pesquisa, selectTitulo } = useCurso()
  const [tipoSelected, setTipoSelected] = useState<'INST' | 'CURSO'>('INST')
  const [bairro, setBairro] = useState('')
  const [selectedInstitution, setSelectedInstitution] = useState<string>('-1')

  const navigate = useNavigate()

  const fetchCities = useCallback(async () => {
    setCities([])
    const _cities = await InstitutionRepository.GetInstance().listCities(
      category,
    )
    setCities((current) => [...current, ..._cities])
  }, [])

  useEffect(() => {
    fetchCities()
  }, [])

  function isEscola(): boolean {
    return (
      category == '2' || category == '5' || category == '8' || category == '9'
    )
  }

  async function fetchNeighborhoods(category_id: string, city: string) {
    setNeighborhoods([])
    setInstitutionsCourses([])
    const neighborhoods =
      await InstitutionRepository.GetInstance().listNeighborhoods(
        category_id,
        city,
      )
    setNeighborhoods(neighborhoods || [])
  }

  function handleBuscar() {
    if (tipoSelected == 'CURSO') {
      if (!category || !city || !bairro || !pesquisa.titulo) return
      navigate(
        `/cursos/${category}/${city.replaceAll(' ', '-')}/${bairro}/${
          pesquisa.titulo
        }`,
      )
    } else {
      const institution = institutions.find(
        (i) => i.id.toString() == selectedInstitution,
      )
      if (!selectedInstitution || !institution) return
      navigate(
        `/cursos/${institution.titulo.replaceAll(
          ' ',
          '-',
        )}/${selectedInstitution}/${category}`,
      )
    }
  }

  async function fetchInstitutions(
    category_id: string,
    cidade: string,
    bairro: string,
  ) {
    const institutionList =
      await InstitutionRepository.GetInstance().listInstitutions(
        Number(category_id),
        cidade,
        bairro,
      )
    setInstitutions(institutionList.institutions)
  }

  async function fetchInstitutionsCourses(
    category_id: string,
    city: string,
    neighborhood: string,
  ) {
    setInstitutionsCourses([])
    if (tipoSelected == 'INST') {
      await fetchInstitutions(category_id, city, neighborhood)
      return
    }

    if (!category || !city) return

    const institutions =
      await CursoRepository.GetInstance().listInstitutionsWithParameters(
        Number(category_id),
        city,
        neighborhood,
      )
    const institutionMapped = institutions.map((t) => t.titulo)
    setInstitutionsCourses([])
    setInstitutionsCourses((current) => [...current, ...institutionMapped])
    selectTitulo(institutionMapped[0])
  }

  return (
    <div className={styles.container}>
      <div className={styles.inputs}>
        <div className={styles.align}>
          <input
            onClick={async () => {
              setTipoSelected('INST')
              await fetchInstitutionsCourses(category, city, bairro)
            }}
            name="tipo"
            type="radio"
            value={isEscola() ? 'Escola' : 'Instituição'}
          />
          <p>{isEscola() ? 'Escola' : 'Instituição'}</p>
        </div>

        <div className={styles.align}>
          <input
            onClick={async () => {
              setTipoSelected('CURSO')
              await fetchInstitutionsCourses(category, city, bairro)
            }}
            name="tipo"
            type="radio"
          />
          <p>{isEscola() ? 'Série' : 'Curso'}</p>
        </div>
      </div>

      <div className={styles.filter}>
        <div className={styles.column}>
          <p>O que deseja estudar?</p>
          <select
            value={category}
            onChange={(e) => setCategory(e.target.value)}
          >
            <option value={'2'}>Ensino Básico</option>
            <option value={'3'}>Técnico</option>
            <option value={'4'}>Profissionalizante</option>
            <option value={'5'}>EJA</option>
            <option value={'6'}>Idiomas</option>
            <option value={'7'}>Pré-Vestibular / Preparatório</option>
            <option value={'9'}>Período Integral</option>
            <option value={'8'}>Faculdade</option>
          </select>
        </div>

        <div className={styles.column}>
          <p>Escolha uma cidade:</p>
          <select
            value={city}
            onChange={async (e) => {
              setCity(e.target.value)
              await fetchNeighborhoods(category, e.target.value)
            }}
          >
            <option>Escolha a cidade...</option>
            {cities?.map((c) => (
              <option>{c}</option>
            ))}
          </select>
        </div>

        <div className={styles.column}>
          <p>Escolha um bairro:</p>
          <select
            onChange={async (e) => {
              setBairro(e.target.value)
              await fetchInstitutionsCourses(category, city, e.target.value)
            }}
          >
            <option>Escolha o bairro...</option>
            {neighborhoods?.map((c) => (
              <option>{c}</option>
            ))}
          </select>
        </div>
        <div className={styles.column}>
          {tipoSelected == 'CURSO' ? (
            <p>{isEscola() ? 'Escolha uma série:' : 'Escolha um curso: '}</p>
          ) : (
            <p>
              {isEscola() ? 'Escolha uma escola:' : 'Escolha uma instituição: '}
            </p>
          )}

          {tipoSelected == 'CURSO' ? (
            <select onChange={(e) => selectTitulo(e.target.value)}>
              <option>
                {isEscola() ? 'Escolha uma série... ' : 'Escolha um curso... '}
              </option>
              {institutionsCourse.length > 0 ? (
                institutionsCourse.map((t) => <option>{t}</option>)
              ) : (
                <option value="none">Nada encontrado...</option>
              )}
            </select>
          ) : (
            <select onChange={(e) => setSelectedInstitution(e.target.value)}>
              <option>
                {isEscola()
                  ? 'Escolha uma escola... '
                  : 'Escolha uma instituição... '}
              </option>
              {institutions.length > 0 ? (
                institutions.map((t) => (
                  <option value={t.id}>{t.titulo}</option>
                ))
              ) : (
                <option value="none">Nada encontrado...</option>
              )}
            </select>
          )}
        </div>
      </div>
      <div>
        <button onClick={handleBuscar} className={styles.button}>
          BUSCAR
        </button>
      </div>
    </div>
  )
}
